<template>
    <div v-cloak v-loading="loading" element-loading-text="正在进入..." class="page-wrapper sys-entry">
        <div class="entrance-header">
            <div class="header-logo">
                <div class="swb-row">
                    <img v-resc-url="'/app/image/logo/plat-logo.png'"/>
                </div>
            </div>
        </div>
        <div class="sys-entry-container">
            <div class="swb-row pt45">
                <div class="content-box">
                    <div class="main-head">
                        <h2>服务商系统</h2>
                        <a @click="doLogout();" class="fr mr15">【退出】</a>
                    </div>
                    <div class="main-body mt20">
                        <div class="notice-search" v-if="entityList.length <= 0 && showNoDate">
                            <div class="ns-wrap">
                                <i class="ns-icon icon iconfont icon-tttt"></i>
                                <div class="ns-content">您还没有服务商身份，您可以&nbsp;&nbsp;<a @click="checkServicer();" class="swb-btn-link">申请服务商</a></div>
                            </div>
                        </div>
                        <div class="sys-ident" v-if="entityList.length > 0">
                            <div class="tabs-nav merchant-choice" style="text-align: right">
                                <!--                                <ul v-if="entityList.length > 0" class="head">-->
                                <!--                                    <li v-if="servicer != null" v-for="servicer in entityList" @click="clickEntity(servicer.id, servicer);" :class="{'current' : servicer.id == selectId}" class="head-item">-->
                                <!--                                        <span>{{ servicer.name }}</span>-->
                                <!--                                    </li>-->
                                <!--                                </ul>-->
                                <template v-if="entityList.length > 0">
                                    <span class="entity-label">请选择商户信息:</span>
                                    <el-select v-model="selectId" collapse-tags placeholder="请选择" @change="clickEntity()" filterable class="entity-select" popper-class="entity-select-dropdown">
                                        <el-option v-for="servicer in entityList" :key="servicer.id" :label="servicer.name" :value="servicer.id"></el-option>
                                    </el-select>
                                </template>

                            </div>
                            <div style="height: 60px;line-height: 35px;" class="hint block">
                                <div class="fl" v-if="bizUnionList != null && bizUnionList.length > 0">
                                    <el-checkbox v-model="forBizUnion" :disabled="hiddenFlag">是否进入联盟</el-checkbox>
                                    <el-select v-if="forBizUnion" class="ml20" v-model="bizUnionId" placeholder="请选择">
                                        <el-option v-for="item in bizUnionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                                <div class="fr">
                                    <el-input class="mt5 mb10" placeholder="请输入机构名称" v-model="searchName">
                                        <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick"></i>
                                    </el-input>
                                </div>
                            </div>
                            <ul v-if="entityInfo != null && entityInfo.servicer.id != null" class="sys-list row-item company-list">
                                <li class="sys-item" style="background-color: #d1dbe5">
                                    <a class="clearfix sys-left">
                                        <div class="company-logo fl">
                                            <img :src="entityInfo.servicer.servicerCom.fileBrowseUrl"/><!-- 总公司的头像 -->
                                        </div>
                                        <div class="company-info fl ml20">
                                            <p class="company-name">{{ entityInfo.servicer.name }}</p>
                                            <p class="company-addr">{{ entityInfo.servicer.createTime }}</p>
                                        </div>
                                    </a>
                                    <div class="sys-right" style="border: none;padding-top: 30px; padding-right: 5px">
                                        <el-select v-if="scopeList.length > 1" v-model="scopeId" placeholder="请选择">
                                            <el-option v-for="item in scopeList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                                        </el-select>
                                        <button v-if="entityInfo.servicer.auditState == 1 && entityInfo.servicer.adminId == userId" style="width: 132px; margin-top: 10px;" class="ellipsis-1 swb-btn swb-btn-mini"
                                                @click="getEntryTarget(entityInfo.servicer.id)">admin
                                        </button>
                                    </div>
                                </li>
                                <li class="sys-item" v-if="entityInfo.servicer.disabled || entityInfo.servicer.outOfBiz" style="background-color: #d1dbe5">
                                    <a class="clearfix sys-left">
                                        <div class="company-logo fl">
                                            <img :src="entityInfo.servicer.servicerCom.fileBrowseUrl"/><!-- 总公司的头像 -->
                                        </div>
                                        <div class="company-info fl ml20">
                                            <p class="company-name">{{ entityInfo.servicer.servicerCom.name }}</p>
                                            <p class="company-addr">
                                                <i class="icon iconfont icon-site-copy mr10"></i>{{ entityInfo.servicer.servicerCom.regionName }}{{ entityInfo.servicer.servicerCom.street }}
                                            </p>
                                        </div>
                                    </a>
                                    <div class="sys-right">
                                        <div class="enter mt30" style="line-height: 22px;padding: 0 10px;">
                                            <div v-if="entityInfo.servicer.disabled" class="font-red">该商户已禁用</div>
                                            <div v-if="!entityInfo.servicer.disabled && entityInfo.servicer.outOfBiz" class="font-red">该商户已歇业</div>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="!entityInfo.servicer.disabled && !entityInfo.servicer.outOfBiz && entityInfo.servicerComs.length > 0" v-for="com in entityInfo.servicerComs" class="sys-item">
                                    <a class="clearfix sys-left">
                                        <div class="company-logo fl">
                                            <img :src="com.fileBrowseUrl"/>
                                        </div>
                                        <div class="company-info fl ml20">
                                            <p class="company-name">{{ com.name }}</p>
                                            <p class="company-addr"><i class="icon iconfont icon-site-copy mr10"></i>{{ com.regionName }}{{ com.street }}</p>
                                        </div>
                                    </a>
                                    <div v-if="entityInfo.servicer.auditState == 1 && !com.staffDisabled && !com.closed" class="sys-right">
                                        <div class="second-caption">岗位进入</div>
                                        <div v-for="comRole in com.comRoles" @click="getEntryTarget(entityInfo.servicer.id, comRole.comId, comRole.id)" class="mt5">
                                            <button style="width: 132px" class="ellipsis-1 swb-btn swb-btn-mini swb-btn-primary">{{ comRole.name }}</button>
                                        </div>
                                    </div>
                                    <div v-if="entityInfo.servicer.auditState == 1 && com.closed" class="sys-right">
                                        <div class="second-caption">岗位进入</div>
                                        <div class="mt20">
                                            <div class="font-red">已闭店</div>
                                        </div>
                                    </div>
                                    <div v-if="entityInfo.servicer.auditState == 1 && com.staffDisabled && !com.closed" class="sys-right">
                                        <div class="enter mt30" style="line-height: 22px;padding: 0 10px;">
                                            <div class="font-red">该员工已禁用</div>
                                        </div>
                                    </div>
                                    <div v-if="entityInfo.servicer.auditState == 0" class="sys-right">
                                        <div class="enter mt30" style="line-height: 22px;padding: 0 10px;">
                                            <div class="font-red">已提交申请</div>
                                            <div class="font-red">等待认证</div>
                                        </div>
                                    </div>
                                    <div v-if="entityInfo.servicer.auditState == -1 && userId != null && entityInfo.servicer.adminId == userId" class="sys-right">
                                        <div class="enter">
                                            <button class="swb-btn swb-btn-primary" @click="checkServicer();">申请服务商</button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="hint block mt20 mb20" v-if="entityInfo.servicer.auditState == -1">
                                <p>
                                    <i class="icon iconfont icon-jinggao1 font-red"></i>
                                    <span class="font-red">审核不通过原因：</span>
                                </p>
                                <p>
                                    <span>{{ entityInfo.servicer.auditDesc }}</span>
                                </p>
                            </div>
                            <div class="sys-ident block pagination-layout" v-if="totalCount > 10">
                                <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" :pager-count="5"
                                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils, Jqext} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../../src/app.conf'

    let Toast = Jqext.Toast;
    let repeatChecker = Utils.repeatChecker;

    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'
    import bizUnionApi from '../../api/bizUnion'

    export default {
        name: 'swb-scope-entity-list',
        desc: '用户-入口选择',
        data: function () {
            return {
                loading: false,
                entityList: [],
                entityListMap: {},
                showNoDate: false,
                entityInfo: {
                    servicer: {},
                    servicerComs: []
                },
                selectId: null,
                forBizUnion: false,
                hiddenFlag: false,
                bizUnionList: [],
                bizUnionId: null,
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                searchName: '',
                userId: null,
                scopeId: null,
                scopeList: [],
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getCurrentUserInfo();
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let userInfo = result.data;
                        self.userId = userInfo.id;
                    } else {
                        self.$message.warning(result.message);
                    }
                    self.getMerchantList();
                });
            },
            handleIconClick: function () {
                this.handlePageChange(1);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                let merchantId = this.selectId;
                this.getMerchantComsByFilter(merchantId);
            },
            clickEntity: function () {
                let id = this.selectId;
                let servicer = this.entityListMap[id];
                //
                let entityInfo = {};
                entityInfo.servicer = servicer;
                entityInfo.servicerComs = [];
                this.entityInfo = Utils.merge({}, entityInfo);
                //
                let scopeList = [];
                let scopeIds = entityInfo.servicer.scopeList || [];
                for (let i = 0; i < scopeIds.length; i++) {
                    let id = scopeIds[i];
                    let scope = getEnumInfoWith("scopeDef", "id", id);
                    scopeList.push(scope);
                }
                if (scopeIds != null && scopeIds.length > 0) {
                    this.scopeId = scopeIds[0];
                }
                this.scopeList = scopeList;
                //
                // 判断是否隐藏商户，隐藏商户只能进入联盟
                let hiddenFlag = entityInfo.servicer.hidden;
                this.hiddenFlag = hiddenFlag;
                if (hiddenFlag) {
                    this.forBizUnion = true;
                } else {
                    this.forBizUnion = false;
                }
                this.bizUnionId = null;
                this.getBizUnionListForUsable(id);
                this.handlePageChange(1);
            },
            getBizUnionListForUsable: function (merchantId) {
                let self = this;
                let theLoad = MsgBox.loading();
                bizUnionApi.getBizUnionListForUsable({merchantId: merchantId}, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        self.bizUnionList = result.data;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getMerchantList: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getMerchantList({}, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        //
                        let entityList = result.data;
                        if (entityList != null && entityList.length > 0) {
                            let entityInfo = {};
                            entityInfo.servicer = entityList[0];
                            self.selectId = entityList[0].id;
                            self.entityInfo = entityInfo;
                            // 判断是否隐藏商户，隐藏商户只能进入联盟
                            let hiddenFlag = entityInfo.servicer.hidden;
                            self.hiddenFlag = hiddenFlag;
                            if (hiddenFlag) {
                                self.forBizUnion = true;
                            }
                            let scopeList = [];
                            let scopeIds = entityInfo.servicer.scopeList || [];
                            for (let i = 0; i < scopeIds.length; i++) {
                                let id = scopeIds[i];
                                let scope = getEnumInfoWith("scopeDef", "id", id);
                                scopeList.push(scope);
                            }
                            if (scopeIds != null && scopeIds.length > 0) {
                                self.scopeId = scopeIds[0];
                            }
                            self.scopeList = scopeList;
                            //
                            self.getMerchantComsByFilter(self.selectId);
                            // 查询联盟信息
                            self.getBizUnionListForUsable(self.selectId);
                        }
                        self.entityList = entityList;
                        self.entityListMap = entityList.toMap('id');
                    } else {
                        self.$message.warning(result.message);
                    }
                    //
                    self.showNoDate = true;
                });
            },
            getMerchantComsByFilter: function (merchantId) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let filterItems = {};
                filterItems.merchantId = merchantId;
                //
                let searchName = this.searchName || null;
                if (!Utils.isNoB(searchName)) {
                    filterItems.name = searchName;
                }
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                userApi.getPcEntryList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let servicerComs = result.data.rows;
                        let entityInfo = self.entityInfo;
                        entityInfo.servicerComs = servicerComs;
                        self.entityInfo = Utils.merge({}, entityInfo);
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getEntryTarget: function (entityId, comId, postId) {
                //方法防重
                if (!repeatChecker.isValidFor('goEntryTarget', 3000)) {
                    Toast.show('重复点击或点击过快', 3000, 'warning')
                    return;
                }
                //
                let self = this;
                let postData = {};
                postData.entityId = entityId;
                postData.comId = comId;
                postData.postId = postId;
                postData.scopeId = this.scopeId;
                if (this.forBizUnion) {
                    if (this.bizUnionId == null) {
                        MsgBox.warning("请选择要进入的联盟！");
                        return;
                    }
                    postData.bizUnionId = this.bizUnionId;
                }
                self.loading = true;
                userApi.getEntryTarget(postData, function (result) {
                    if (result.type === "info") {
                        let curLocation = window.location;
                        if (curLocation.pathname.indexOf('/bench/home') != -1 && curLocation.hash) {
                            //可能是从控制台转过来的带hash的url
                            window.location.reload(true);
                        } else {
                            let targetUrl = getAppUrl(result.data);
                            window.location.href = targetUrl;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                    self.loading = false;
                });
            },
            doLogout: function () {
                let theLoad = MsgBox.loading();
                userApi.doUserLogout({}, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        window.location.href = getAppUrl("/user/login/jsp");
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkServicer: function () {
                let theLoad = MsgBox.loading();
                servicerApi.getServicerCheckResult({}, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        if (result.code === 0) {
                            window.location.href = getAppUrl("/servicer/regist/jsp");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

        },
    }
</script>
<style>
    .entity-label {
        font-size: 20px;
        color: #0c64eb;
        margin-right: 10px;
    }

    .entity-select {
        width: 400px;
    }

    .entity-select .el-input__inner {
        height: 50px;
    }

    .entity-select .el-input,
    .entity-select-dropdown .el-select-dropdown__item {
        font-size: 20px;
    }
</style>




// WEBPACK FOOTER //
// src/compo/user/ScopeEntityList.vue